import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// GET =>  getStudentsForSchool
export const getStudentsForSchool = createAsyncThunk(
  "student/getStudentsForSchool",
  async (prams, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getStudentsForSchoolURL, {
        params: {
          school_id: prams?.school_id,
          page: prams?.page,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  add StudentForSchool
export const addStudentForSchool = createAsyncThunk(
  "student/addStudentForSchool",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addStudentForSchoolURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// DELETE =>  deleteStudent
export const deleteStudent = createAsyncThunk(
  "student/deleteStudent",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.deleteStudentURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  getStudentsForSection
export const getStudentsForSection = createAsyncThunk(
  "student/getStudentsForSection",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.getStudentsForSectionURL}/${id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get Sending Notes
export const getSendingNotes = createAsyncThunk(
  "student/getSendingNotes",
  async (prams, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getSchoolNotesURL, {
        params: {
          student_id: prams?.student_id,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  get search Student
export const searchStudent = createAsyncThunk(
  "student/searchStudent",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.searchStudentURL, {
        params: {
          school_id: params?.school_id,
          search: params?.search,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  add StudentForSchool
export const editStudent = createAsyncThunk(
  "student/editStudent",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(
        `${URLS.editStudentURL}/${params.student_id}`,
        params?.data,
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  showGradesForAllMaterials
export const showGradesForAllMaterials = createAsyncThunk(
  "student/showGradesForAllMaterials",
  async (params, thunkAPI) => {
    console.log("hiiiiiii", params);
    try {
      const response = await axios.get(
        `${URLS.showGradesForAllMaterialsURL}/${params.id}`,
        {
          params: {
            last_season: params?.last_season,
          },
        }
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// Post =>  addNewGrade
export const addNewGrade = createAsyncThunk(
  "student/addNewGrade",
  async (data, thunkAPI) => {
    console.log("data is :", data);
    try {
      const response = await axios.post(URLS.addNewGradeURL, data.gradeData, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },

        params: {
          last_season: data?.last_season,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  getStudentsForParent
export const getStudentsForParent = createAsyncThunk(
  "student/getStudentsForParent",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.getStudentsForParentURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  getAllStudents
export const getAllStudents = createAsyncThunk(
  "student/getAllStudents",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.getAllStudentsURL, {
        params: {
          page: params?.page,
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// GET =>  getStudentPayments
export const getStudentPayments = createAsyncThunk(
  "student/getStudentPayments",
  async (student_id, thunkAPI) => {
    try {
      const response = await axios.get(
        `${URLS.getStudentPaymentsURL}/${student_id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// DELETE =>  getStudentPayments
export const deleteStudentPayment = createAsyncThunk(
  "student/deleteStudentPayment",
  async (payment_id, thunkAPI) => {
    try {
      const response = await axios.delete(
        `${URLS.deleteStudentPaymentURL}/${payment_id}`
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST =>  addStudentPayment
export const addStudentPayment = createAsyncThunk(
  "student/addStudentPayment",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addStudentPaymentURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST => addPointsForStudentsURL
export const addPointsForStudents = createAsyncThunk(
  "student/addPointsForStudents",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addPointsForStudentsURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// POST => Delete Grade
export const deleteGrade = createAsyncThunk(
  "student/deleteGrade",
  async (data, thunkAPI) => {
    console.log("data");
    console.log(data);
    try {
      const response = await axios.post(URLS.deleteGrade, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

// addPoints
export const addPointsToStudent = createAsyncThunk(
  "student/addPoints",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.addPoints, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
